import { mediaQueries } from '@fourthwall/components';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  display: flex;
  gap: 12px;
  flex-direction: column;

  ${mediaQueries.tablet} {
    flex-direction: row;
    gap: 0;
  }
`;
export const ButtonWrapper = styled.div `
  display: flex;
  gap: 12px;

  ${mediaQueries.tablet} {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  & > button:first-child {
    ${mediaQueries.tablet} {
      margin-right: 4px; // Additional adjustment for visual balance with gap
    }
  }
`;
export const InputWrapper = styled.div `
  flex: 1;
`;
export const SocialButtonsWrapper = styled.div `
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;

  ${mediaQueries.tablet} {
    flex-wrap: nowrap;
    gap: 16px;
  }
`;
